import * as React from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const InfoList = styled("ol")`
  list-style: none;
  margin: 8px 0 0 0;
  padding: 0;

  li {
    padding-top: 8px;
  }
`;

const Green = styled("span")`
  color: #65a300;
`;

export default function RepresentmentInfoText() {
  return (
    <div>
      <Typography variant="h1">
        <strong>Instruções</strong> <br /> para envio de arquivos <br /> para a
        contestação de chargeback
      </Typography>
      <InfoList>
        <li>
          <Green>✓</Green> Os documentos devem estar no formato{" "}
          <strong>PDF</strong> ou <strong>JPG</strong>;
        </li>
        <li>
          <Green>✓</Green> Nomeados com o identificador da transação (número
          encontrado na primeira coluna nomeada como coluna "A" dentro da
          planilha enviada por e-mail, que identifica qual venda você está
          contestando).
        </li>
        <li>
          <Green>✓</Green> O tamanho total de arquivos{" "}
          <strong>não pode ser maior do que 50MB</strong>.<br /> Sendo um ou
          mais documentos, o total deve respeitar esse limite.
        </li>
        <li>
          Caso ainda tenha dúvidas, nossa central de ajuda possui informações
          sobre a{" "}
          <a
            id="chargeback-faq"
            href="https://pagarme.helpjuice.com/pt_BR/p10-seguran%C3%A7a/chargeback-%7C-reapresenta%C3%A7%C3%A3o-de-chargeback"
          >
            contestação de chargeback
          </a>
          .
        </li>
      </InfoList>
    </div>
  );
}
